// extracted by mini-css-extract-plugin
export default {"wrapper":"AnimatedWrapper_wrapper__jeFfY","visible":"AnimatedWrapper_visible__stUph"};